import './corvette/style';
import FormStructure from './corvette/form_structure';

export default FormStructure;